import React from 'react'

import Box from 'airship/patterns/Box'

import styles from './styles.module.css'

interface Props {
  title: string
  preTitleChild?: React.ReactNode
}

const CenteredTitledBox: React.FC<Props> = ({
  title,
  preTitleChild,
  children,
}) => {
  // Add some extra space to the top if there is no preTitleChild
  const innerStyles = preTitleChild
    ? `${styles.inner}`
    : `${styles.inner} ${styles.marginTopSm}`

  return (
    <Box displayClasses={styles.outer} raised={true}>
      {preTitleChild && (
        <div className={styles.preTitleChild}>{preTitleChild}</div>
      )}
      <div className={innerStyles}>
        <div className={styles.title}>{title}</div>
        <div className={styles.child}>{children}</div>
      </div>
    </Box>
  )
}

export default CenteredTitledBox
